<template>
  <div>
    <v-dialog
      v-model="dialog"
      fullscreen
      eager
      persistent
      scrollable
      max-width="900px"
    >
      <v-card>
        <!-- <v-card-title dark class="dialog-header pt-5 pb-5 pl-6">
          <span>OPCR Targets</span>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="closeD()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title> -->

        <v-card-title dark class="dialog-header">
          <div class="dialog-header-content">
            <div class="dialog-title-wrapper">
              <div class="dialog-icon">
                <icon name="global-icon" />
              </div>

              <div class="dialog-text">
                <div class="dialog-title">OPCR Targets</div>

                <div class="dialog-subtitle">
                  Establish office performance targets, indicators, and expected
                  results.
                </div>
              </div>
            </div>

            <v-btn icon class="close-btn" @click="closeD()">
              <icon name="circle-close" />
            </v-btn>
          </div>
        </v-card-title>

        <v-card-text style="max-height: 700px" class="my-4">
          <v-row>
            <v-col cols="12" v-if="isSubmitted">
              <v-stepper alt-labels class="elevation-0">
                <v-stepper-header>
                  <v-stepper-step
                    step="1"
                    class="pa-5"
                    :complete="
                      data && data.target_submission.imm_approval_status == 2
                        ? true
                        : false
                    "
                    :rules="[
                      () =>
                        data && data.target_submission.imm_approval_status != 3,
                    ]"
                    color="#147452"
                  >
                    <div style="width: 200px" class="text-center">
                      {{
                        data.target_submission.imm_head
                          ? getUserName(data.target_submission.imm_head)
                          : ""
                      }}
                    </div>
                    <small>Assessed By<br /> </small>
                  </v-stepper-step>
                  <v-divider></v-divider>
                  <v-stepper-step
                    step="2"
                    class="pa-5"
                    :complete="
                      data &&
                      data.target_submission.planning_user_approval_status == 2
                        ? true
                        : false
                    "
                    :rules="[
                      () =>
                        data &&
                        data.target_submission.planning_user_approval_status !=
                          3,
                    ]"
                    color="#6DB249"
                  >
                    <div style="width: 200px" class="text-center">
                      {{
                        data.target_submission.planning_user_approver
                          ? getUserName(
                              data.target_submission.planning_user_approver,
                            )
                          : ""
                      }}
                    </div>
                    <small>Planning <br /> </small>
                  </v-stepper-step>
                  <v-divider></v-divider>
                  <v-stepper-step
                    step="3"
                    class="pa-5"
                    :complete="
                      data && data.target_submission.cpmt_approval_status == 2
                        ? true
                        : false
                    "
                    :rules="[
                      () =>
                        data &&
                        data.target_submission.cpmt_approval_status != 3,
                    ]"
                    color="#6DB249"
                  >
                    <div style="width: 200px" class="text-center">
                      {{
                        data.target_submission.cpmt_approver
                          ? getUserName(data.target_submission.cpmt_approver)
                          : ""
                      }}
                    </div>
                    <small>CPMT <br /> </small>
                  </v-stepper-step>
                  <v-divider></v-divider>
                  <v-stepper-step
                    step="4"
                    class="pa-5"
                    :complete="
                      data &&
                      data.target_submission.president_approval_status == 2
                        ? true
                        : false
                    "
                    :rules="[
                      () =>
                        data &&
                        data.target_submission.president_approval_status != 3,
                    ]"
                    color="#6DB249"
                  >
                    <div style="width: 200px" class="text-center">
                      {{
                        data.target_submission.president_approver
                          ? getUserName(
                              data.target_submission.president_approver,
                            )
                          : ""
                      }}
                    </div>
                    <small>President <br /> </small>
                  </v-stepper-step>
                </v-stepper-header>
              </v-stepper>
            </v-col>
            <v-col cols="8" class="flex-items mt-2">
              <v-tabs v-model="activeTab" color="#519043" align-tabs="left">
                <v-tab
                  v-for="tab in tabList"
                  :key="tab.id"
                  @change="changeTab(tab)"
                  >{{ tab.name }}</v-tab
                >
              </v-tabs>
            </v-col>
            <v-spacer></v-spacer>
            <v-col cols="2" class="d-flex justify-end mt-2 mr-2">
              <v-btn
                v-if="shouldSubmit() && tab != 3"
                @click="AddFunction()"
                class="btn-save"
                color="#519043"
              >
                Add {{ tab == 2 ? "OIP" : "" }}
              </v-btn>
            </v-col>
            <v-col cols="12" class="pt-2 px-4">
              <v-card class="dt-container" elevation="0" outlined>
                <v-data-table
                  :headers="
                    tab == 1
                      ? cf_headers
                      : tab == 2
                      ? sp_headers
                      : support_headers
                  "
                  :items="dataItem"
                  :items-per-page="10"
                  :item-class="setPendingClass"
                >
                  <template v-slot:[`item.code`]="{ item }">
                    <span v-if="item.sp_type === 'pap'" class="text-center">
                      {{
                        item.suc_code
                          ? `${item.code} / ${item.suc_code}`
                          : item.gaa_code
                          ? `${item.code} / ${item.gaa_code}`
                          : item.drdp_code
                          ? `${item.code} / ${item.drdp_code}`
                          : item.code
                      }}
                    </span>

                    <span
                      v-else-if="item.sp_type === 'suc_lvl'"
                      class="text-center"
                    >
                      {{
                        item.gaa_code
                          ? `${item.code} / ${item.gaa_code}`
                          : item.drdp_code
                          ? `${item.code} / ${item.gaa_code}`
                          : item.code
                      }}
                    </span>

                    <span
                      v-else-if="item.sp_type === 'gaa'"
                      class="text-center"
                    >
                      {{
                        item.drdp_code
                          ? `${item.code} / ${item.drdp_code}`
                          : item.code
                      }}
                    </span>

                    <span v-else>
                      <span v-if="item.code">
                        {{ item.code }}
                      </span>
                      <span v-else>
                        {{ getOipNumber(item) }}
                      </span>
                    </span>
                  </template>
                  <template v-slot:[`item.eqt`]="{ item }">
                    <div class="text-center">
                      <div class="d-flex align-center justify-center">
                        <div class="text-caption">E -</div>
                        <div class="align-self-center">
                          <v-icon v-if="item.eff_is_rated" color="#519043"
                            >mdi-check</v-icon
                          >
                          <v-chip v-if="!item.eff_is_rated" x-small>NR</v-chip>
                        </div>
                      </div>
                      <div class="d-flex align-center justify-center">
                        <div class="text-caption">Q -</div>
                        <div class="align-self-center">
                          <v-icon v-if="item.qly_is_rated" color="#519043"
                            >mdi-check</v-icon
                          >
                          <v-chip v-if="!item.qly_is_rated" x-small>NR</v-chip>
                        </div>
                      </div>
                      <div class="d-flex align-center justify-center">
                        <div class="text-caption">T -</div>

                        <div class="align-self-center">
                          <v-icon
                            v-if="item.timeliness_is_rated"
                            color="#519043"
                            >mdi-check</v-icon
                          >
                          <v-chip v-if="!item.timeliness_is_rated" x-small
                            >NR</v-chip
                          >
                        </div>
                      </div>
                    </div>
                  </template>
                  <template v-slot:[`item.is_tagged`]="{ item }">
                    <v-chip
                      x-small
                      class="white--text"
                      :color="
                        item.OpcrPapTargetDistributedTaggingCount &&
                        (item.opcr_pap_target_distributed_tagging_ID ||
                          item.OpcrPapTargetDistributedTaggingID)
                          ? '#519043'
                          : 'warning'
                      "
                    >
                      {{
                        item.OpcrPapTargetDistributedTaggingCount &&
                        (item.opcr_pap_target_distributed_tagging_ID ||
                          item.OpcrPapTargetDistributedTaggingID)
                          ? "Yes"
                          : "No"
                      }}
                    </v-chip>
                  </template>
                  <template v-slot:[`item.alloted_budget`]="{ item }">
                    {{
                      item.alloted_budget
                        ? formatPrice(item.alloted_budget)
                        : ""
                    }}
                  </template>

                  <template v-slot:[`item.isDistributed`]="{ item }">
                    <v-chip
                      v-if="!item.isOIP"
                      x-small
                      class="white--text"
                      :color="item.isDistributed ? '#519043' : 'warning'"
                    >
                      {{ item.isDistributed ? "Yes" : "No" }}
                    </v-chip>
                    <!-- <v-chip
                      v-else
                      x-small
                      class="white--text"
                      :color="
                        item.OpcrPapTargetDistributedTaggingCount &&
                        (item.opcr_pap_target_distributed_tagging_ID ||
                          item.OpcrPapTargetDistributedTaggingID)
                          ? '#519043'
                          : 'warning'
                      "
                    >
                      {{
                        item.OpcrPapTargetDistributedTaggingCount &&
                        (item.opcr_pap_target_distributed_tagging_ID ||
                          item.OpcrPapTargetDistributedTaggingID)
                          ? "Yes"
                          : "No"
                      }}
                    </v-chip> -->
                  </template>

                  <!-- <template v-slot:expanded-item="{ headers, item }">
                    <td :colspan="headers.length" class="pa-4">
                      <div class="text-subtitle-1 py-1">Linked IPCR</div>
                      <div v-if="item.linkedIPCR.length > 0">
                        <v-data-table
                          :headers="linked_headers"
                          :items="item.linkedIPCR"
                          hide-default-footer
                        >
                        </v-data-table>
                      </div>
                      <div
                        v-if="item.linkedIPCR.length == 0"
                        class="text-center"
                      >
                        <div class="text-caption"><i>No linked IPCR</i></div>
                      </div>
                    </td>
                  </template> -->
                  <template
                    v-slot:[`item.action`]="{ item }"
                    v-if="shouldSubmit()"
                  >
                    <div class="button-group pa-2">
                      <v-btn
                        v-if="
                          shouldSubmit() &&
                            hasUnOpennedRemarks(item.pending_remarks)
                        "
                        class="global-btn-save"
                        @click="showPendingRemarks(item.pending_remarks)"
                        >Show Remarks</v-btn
                      >
                      <span
                        v-if="tab != 3"
                        v-show="
                          item.sp_type != 'suc_lvl' &&
                            item.sp_type != 'gaa' &&
                            item.sp_type != 'drdp'
                        "
                      >
                        <v-btn
                          :block="tab != 3"
                          @click="edit(item)"
                          class="global-btn-save"
                          >Update
                          {{ tab == 2 && !item.isOIP ? "" : "" }}
                        </v-btn>
                      </span>

                      <v-btn
                        :block="tab != 3"
                        v-if="
                          tab == 2 &&
                            item.isDistributed &&
                            getPositionToTag.canTag
                        "
                        v-show="
                          !['unit_head', 'dean'].includes(myTaggingType.type)
                        "
                        class="global-btn-save"
                        @click="tag(item)"
                        >Tag</v-btn
                      >
                      <span
                        v-if="tab != 3"
                        v-show="
                          item.sp_type != 'suc_lvl' &&
                            item.sp_type != 'gaa' &&
                            item.sp_type != 'drdp' &&
                            item.sp_type != 'pap'
                        "
                      >
                        <v-btn
                          v-if="
                            item.opcr_pap_target_distributed_tagging_ID == null
                          "
                          v-show="data.id == item.opcrID"
                          :block="tab != 3"
                          @click="deleteItem(item)"
                          class="global-btn-cancel"
                          >Delete
                        </v-btn>
                      </span>
                    </div>
                  </template>
                </v-data-table>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="justify-end">
          <v-card-text class="pa-1 mr-3 mt-8 d-flex justify-end">
            <v-spacer></v-spacer>

            <v-btn class="btn-cancel mr-3" outlined @click="closeD()">
              Close
            </v-btn>

            <!-- <v-btn
              v-if="shouldSubmit()"
              color="#519043"
              class="btn-save"
              @click="submitTarget()"
            >
              Submit
            </v-btn> -->
          </v-card-text>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- delete dialog -->
    <v-dialog
      v-model="confirmDialog"
      persistent
      max-width="420"
      content-class="delete-dialog-content"
    >
      <v-card class="delete-dialog">
        <div class="delete-content">
          <div class="delete-icon">
            <icon name="delete" />
          </div>

          <div class="delete-title">Delete Record?</div>

          <div class="delete-description">
            Are you sure you want to delete this
            {{ tab == 1 ? "Core Function" : "Other Institutional Priority" }}?
            <br /><br />
            <strong>This action cannot be undone.</strong>
          </div>
        </div>

        <v-divider />

        <v-card-actions class="pa-4">
          <v-btn
            text
            color="grey darken-1"
            class="btn-cancel"
            :disabled="isButtonLoading"
            @click="cancelDelete()"
          >
            Cancel
          </v-btn>

          <v-spacer />

          <v-btn
            color="#dc2612"
            depressed
            class="btn-cancel-success"
            :loading="isButtonLoading"
            :disabled="isButtonLoading"
            @click="confirmDelete()"
          >
            Delete
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="confirmSubmitDialog"
      persistent
      max-width="420"
      content-class="delete-dialog-content"
    >
      <v-card class="delete-dialog">
        <div class="delete-content">
          <div class="submit-icon">
            <icon name="circle-check" />
          </div>

          <div class="delete-title">Submit for Approval?</div>

          <div class="delete-description">
            Are you sure you want to submit this
            <strong>Target for Approval</strong>?
          </div>
        </div>

        <v-divider />

        <v-card-actions class="pa-4">
          <v-btn
            text
            color="grey darken-1"
            class="btn-cancel"
            :disabled="confirmBtnLoading"
            @click="cancelConfirm()"
          >
            Cancel
          </v-btn>

          <v-spacer />

          <v-btn
            color="#147452"
            depressed
            class="btn-save"
            :loading="confirmBtnLoading"
            :disabled="confirmBtnLoading"
            @click="confirmSubmit()"
          >
            Confirm
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- tagging -->
    <v-dialog
      v-model="taggingDialog"
      eager
      persistent
      scrollable
      max-width="1000px"
      content-class="rounded-dialog"
    >
      <v-card>
        <!-- <v-card-title dark class="dialog-header pt-5 pb-5 pl-6">
          <span></span>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="taggingDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title> -->
        <v-card-title dark class="dialog-header">
          <div class="dialog-header-content">
            <div class="dialog-title-wrapper">
              <div class="dialog-icon">
                <icon name="circle-add" />
              </div>

              <div class="dialog-text">
                <div class="dialog-title">
                  {{ isTargetNeedForTagging ? "Distribute Targets" : "" }}
                </div>

                <div class="dialog-subtitle">
                  Fill in the required information belows
                </div>
              </div>
            </div>

            <v-btn icon class="close-btn" @click="taggingDialog = false">
              <icon name="circle-close" />
            </v-btn>
          </div>
        </v-card-title>
        <v-card-text style="max-height: 700px" class="my-6">
          <v-form ref="TargetDialogRef" @submit.prevent>
            <v-row>
              <!-- Target to Distribute -->
              <v-col cols="12" v-if="isTargetNeedForTagging">
                <v-text-field
                  v-model="target_to_distribute"
                  label="Targets to Distribute"
                  outlined
                  readonly
                  class="rounded-lg"
                  color="#6DB249"
                ></v-text-field>
              </v-col>

              <!-- Tagged Heads -->
              <v-col cols="12">
                <div class="global-list-card">
                  <!-- Header -->
                  <div class="global-list-header1">
                    <div>
                      <div class="global-title">
                        <v-icon size="18" color="#147452" class="mr-2">
                          mdi-tag-outline
                        </v-icon>

                        <span>
                          {{ getPositionToTag.label }}
                          &nbsp;
                          <span class="primary--text font-weight-bold">
                            {{ getPositionToTag.toTag }}
                          </span>
                        </span>
                      </div>

                      <div class="global-subtitle">
                        Select an OPCR target to associate with this entry.
                      </div>
                    </div>

                    <div>
                      <v-btn
                        @click="add_head_tagging()"
                        class="btn-save"
                        color="#519043"
                      >
                        Add
                      </v-btn>
                    </div>
                  </div>

                  <!-- Content -->
                  <div class="pa-4">
                    <v-card class="dt-container mt-4" elevation="0" outlined>
                      <v-data-table
                        :headers="tagged_head_headers"
                        :items="tagged_head_data"
                        hide-default-footer
                      >
                        <!-- Target -->
                        <template
                          v-slot:[`item.target`]="{ item }"
                          v-if="isTargetNeedForTagging"
                        >
                          <div>
                            {{
                              sdp_target_format == "numeric"
                                ? item.target
                                : item.target + "%"
                            }}
                          </div>
                        </template>

                        <!-- Actions -->
                        <template v-slot:[`item.action`]="{ item, index }">
                          <div class="button-group pa-2">
                            <v-btn
                              class="global-btn-save"
                              @click="edit_tag(item, index)"
                            >
                              Edit
                            </v-btn>

                            <v-btn class="global-btn-save" @click="untag(item)">
                              Untag
                            </v-btn>
                          </div>
                        </template>

                        <!-- Empty State -->
                        <template v-slot:no-data>
                          <div class="text-center py-8 grey--text">
                            <v-icon size="42" color="grey lighten-1">
                              mdi-account-tag-outline
                            </v-icon>
                            <div class="mt-2">No tagged heads found.</div>
                          </div>
                        </template>
                      </v-data-table>
                    </v-card>
                  </div>
                </div>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="pa-5">
          <v-spacer></v-spacer>
          <v-btn class="btn-cancel" outlined @click="taggingDialog = false">
            Cancel
          </v-btn>

          <v-btn
            outlined
            class="btn-save"
            @click="saveTagging()"
            :loading="taggingBtnLoading"
            :disabled="taggingBtnLoading"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- heads users dialog-->
    <v-dialog
      v-model="headsDialog"
      eager
      persistent
      scrollable
      max-width="500px"
      content-class="rounded-dialog"
    >
      <v-card>
        <!-- Header -->
        <v-card-title dark class="dialog-header">
          <div class="dialog-header-content">
            <div class="dialog-title-wrapper">
              <div class="dialog-icon">
                <icon name="circle-add" />
              </div>

              <div class="dialog-text">
                <div class="dialog-title">
                  Select
                  {{ isTargetNeedForTagging ? "Head/Office" : "Personnel" }}
                </div>

                <div class="dialog-subtitle">
                  Fill in the required information belows
                </div>
              </div>
            </div>

            <v-btn icon class="close-btn" @click="closeHeadsDialog()">
              <icon name="circle-close" />
            </v-btn>
          </div>
        </v-card-title>

        <!-- Body -->
        <v-card-text style="max-height: 700px" class="my-4">
          <v-form ref="HeadsDialogRef" @submit.prevent>
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-autocomplete
                    v-model="tagged_head_temp_data"
                    :label="
                      isTargetNeedForTagging ? 'Head/Office' : 'Personnel'
                    "
                    outlined
                    class="rounded-lg"
                    item-text="name"
                    item-value="usID"
                    color="#93CB5B"
                    :items="tempHeadsList"
                  >
                    <template v-slot:selection="data">
                      <v-chip
                        v-bind="data.attrs"
                        :input-value="data.selected"
                        small
                        @click="data.select"
                        @click:close="removeTaggedOnClick(data.item)"
                      >
                        {{ data.item.name }}
                      </v-chip>
                    </template>

                    <template v-slot:item="data">
                      <v-list-item-content>
                        <v-list-item-title
                          v-html="data.item.name"
                        ></v-list-item-title>

                        <v-list-item-subtitle
                          v-html="data.item.office"
                        ></v-list-item-subtitle>
                      </v-list-item-content>
                    </template>
                  </v-autocomplete>
                </v-col>

                <v-col cols="12" v-if="isTargetNeedForTagging">
                  <v-text-field
                    v-model="head_target"
                    type="number"
                    :rules="isTargetNeedForTagging ? [formRules.required] : []"
                    outlined
                    required
                    label="Target"
                    class="rounded-lg"
                    color="#6DB249"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <!-- Footer -->
        <v-card-actions class="pa-5">
          <v-spacer></v-spacer>

          <v-btn class="btn-cancel" outlined @click="closeHeadsDialog()">
            Cancel
          </v-btn>

          <v-btn
            color="#519043"
            class="btn-save"
            v-if="tagHeadAction == 'Add'"
            :loading="targetBtnLoading"
            :disabled="targetBtnLoading"
            @click="saveTaggedHeads()"
          >
            Add
          </v-btn>

          <v-btn
            color="#519043"
            class="btn-save"
            v-if="tagHeadAction == 'Update'"
            @click="updateTaggedHeads()"
            :loading="targetBtnLoading"
            :disabled="targetBtnLoading"
          >
            Update
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- untag dialog -->
    <v-dialog
      v-if="unTagDialog"
      v-model="unTagDialog"
      persistent
      max-width="420"
      content-class="delete-dialog-content"
    >
      <v-card class="delete-dialog">
        <div class="delete-content">
          <div class="submit-icon">
            <icon name="circle-question" />
          </div>

          <div class="delete-title">Warning!</div>

          <div class="delete-description">
            Are you sure you want to untag
            <strong>{{ unTagUser.head_user.name }}</strong
            >?
          </div>
        </div>

        <v-divider />

        <v-card-actions class="pa-4">
          <v-btn
            text
            color="grey darken-1"
            class="btn-cancel"
            :disabled="confirmBtnLoading"
            @click="cancelUntag()"
          >
            Close
          </v-btn>

          <v-spacer />

          <v-btn
            color="#147452"
            depressed
            class="btn-save"
            :loading="confirmBtnLoading"
            :disabled="confirmBtnLoading"
            @click="confirmUntag()"
          >
            Confirm
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <AddOPCRTargetsDialog
      :data="opcrData"
      :action="action"
      :opcrID="id"
      :myTaggingType="myTaggingType"
      :tab="tab"
      :isToUpdate="isToUpdate"
    />
    <UpdateStategicTargetSuccessIndicatorDialog
      :data="opcr1Data"
      :action="action"
      :opcrID="id"
    />
    <UpdateSupportFunctionDialog
      :data="opcrSupData"
      :action="action"
      :opcrID="id"
    />

    <ViewRemarksTimelineDialog
      :data="pendingList"
      :viewFrom="'Owner'"
      v-on:closeRemarksTimeline="initialize()"
    />
    <fade-away-message-component
      displayType="variation2"
      v-model="fadeAwayMessage.show"
      :message="fadeAwayMessage.message"
      :header="fadeAwayMessage.header"
      :top="fadeAwayMessage.top"
      :type="fadeAwayMessage.type"
    ></fade-away-message-component>
  </div>
</template>

<script>
import ViewRemarksTimelineDialog from "../../Views/ViewRemarksTimelineDialog.vue";
import UpdateStategicTargetSuccessIndicatorDialog from "./UpdateStategicTargetSuccessIndicatorDialog.vue";
import icon from "@/assets/icon.vue";
export default {
  components: {
    AddOPCRTargetsDialog: () => import("../OPCR/AddOPCRTargetsDialog.vue"),
    UpdateSupportFunctionDialog: () =>
      import("../OPCR/UpdateOPCRSupportFunctionDialog.vue"),
    // AddIPCRSupportUtilDialog: () =>
    //   import("../Forms/AddIPCRSupportUtilDialog.vue"),
    ViewRemarksTimelineDialog,
    UpdateStategicTargetSuccessIndicatorDialog,
    icon,
  },
  props: {
    data: null,
  },
  data() {
    return {
      pendingList: [],
      remarksData: [],
      isToUpdate: true,
      taggingDialog: false,
      taggingBtnLoading: false,
      confirmBtnLoading: false,
      confirmSubmitDialog: false,
      confirmDialog: false,
      itemToDelete: null,
      assesed_by_status: null,
      options: {},
      action: null,
      fadeAwayMessage: {
        show: false,
        type: "success",
        header: "Successfully Added!",
        message: "",
        top: 10,
      },
      mporData: [],
      dialog: false,
      activeTab: { id: 1, name: "Core Functions" },
      tab: 1,
      tabList: [
        { id: 1, name: "Core Functions" },
        { id: 2, name: "Strategic Priority" },
        { id: 3, name: "Support Functions" },
      ],
      opcrData: null,
      opcr1Data: null,
      opcrSupData: null,
      isSubmitted: null,
      targetRating: null,
      isSubmitLoading: false,
      assessed_by: null,
      assessed_by_status: null,
      final_rating_by: null,
      final_rating_by_status: null,
      id: null,
      ipcrSupport: null,
      dataItem: [],
      expanded: [],
      isButtonLoading: false,
      tagged_head_data: [],
      head_target: null,
      tagged_head_headers: [
        {
          text: "Name",
          value: "head_user.name",
          align: "start",
          valign: "start",
          sortable: false,
        },
        {
          text: "Office",
          value: "head_user.office",
          align: "start",
          valign: "start",
          sortable: false,
        },
        {
          text: "Targets",
          value: "target",
          align: "start",
          valign: "start",
          sortable: false,
        },
        {
          text: "Action",
          value: "action",
          align: "center",
          valign: "center",
          width: 200,
        },
      ],
      cf_headers: [
        {
          text: "Major Final Output",
          value: "mfo",
          width: 300,
          align: "start",
          valign: "start",
          sortable: false,
        },
        {
          text: "Success Indicator",
          value: "success_indicator",
          align: "start",
          width: 300,
          valign: "center",
          sortable: false,
        },
        {
          text: "Alloted Budget",
          value: "alloted_budget",
          align: "center",
          valign: "center",
          sortable: false,
        },
        {
          text: "Is A Tagged Target",
          value: "is_tagged",
          align: "center",
          valign: "center",
          sortable: false,
        },

        // {
        //   text: "Rating",
        //   value: "eqt",
        //   align: "center",
        //   valign: "center",
        //   sortable: false,
        // },
        {
          text: "Action",
          value: "action",
          width: 150,
          align: "end",
        },
      ],
      sp_headers: [
        {
          text: "Code",
          value: "code",
          width: 300,
          align: "start",
          valign: "start",
          sortable: false,
        },
        {
          text: "Major Final Output",
          value: "mfo",
          width: 300,
          align: "start",
          valign: "start",
          sortable: false,
        },
        {
          text: "Success Indicator",
          value: "success_indicator",
          align: "start",
          width: 300,
          valign: "center",
          sortable: false,
        },
        {
          text: "Alloted Budget",
          value: "alloted_budget",
          align: "center",
          valign: "center",
          sortable: false,
        },

        {
          text: "Is Distributed",
          value: "isDistributed",
          align: "center",
          valign: "center",
          sortable: false,
        },
        {
          text: "Action",
          value: "action",
          width: 150,
          align: "end",
        },
      ],
      usersList: [],
      linked_headers: [
        {
          text: "Employee",
          value: "name",
          align: "start",
          valign: "start",
          sortable: false,
        },
        {
          text: "Success Indicator",
          value: "success_indicator",
          align: "start",
          valign: "center",
          sortable: false,
        },
      ],
      support_headers: [
        {
          text: "Success Indicator",
          value: "success_indicator",
          align: "start",
          sortable: false,
        },
        {
          text: "Actual Accomplishment",
          value: "actual_accom",
          align: "center",

          valign: "center",
          sortable: false,
        },

        {
          text: "To be Rated",
          value: "eqt",
          align: "center",
          valign: "center",
          sortable: false,
        },
        {
          text: "Action",
          value: "action",
          align: "end",
        },
      ],
      itemForTagging: null,
      tagIdxToUpdate: null,
      target_to_distribute: null,
      tempHeadsList: [],
      taggingType: null,
      tagHeadAction: null,
      headsDialog: false,
      tagged_head_temp_data: null,
      targetBtnLoading: false,
      unTagUser: null,
      unTagDialog: false,
      untagList: [],
      sdp_target_format: null,
      myTaggingType: null,
    };
  },

  watch: {
    data: {
      handler(data) {
        this.dialog = true;
        console.log("DSASD", data);
        this.isSubmitted = data.target_submission.is_submitted;
        // this.assessed_by = this.toTitleCase(data.assessed_by_name);
        this.assessed_by_status = data.imm_approval_status;
        this.id = data.id;
        this.activeTab = { id: 1, name: "Core Functions" };
        this.tab = 1;
        this.initialize();
        this.getHeadUsers();
        this.getMyTaggingType();
      },
      deep: true,
    },
    options: {
      handler() {
        this.initialize();
      },
      deep: true,
    },
  },
  mounted() {
    console.log("employee ", this.$store.state.emp);
    this.eventHub.$on("closeAddOPCRTargetsDialog", () => {
      this.initialize();
    });
    this.eventHub.$on("closeUpdateOPCRSupportFunctionDialog", () => {
      this.initialize();
    });
    this.eventHub.$on(
      "closeUpdateStrategicTargetSuccessIndicatorDialog",
      () => {
        this.initialize();
      },
    );
    // this.eventHub.$on("closeUpdateSupportFunctionDialog", () => {
    //   this.initialize();
    // });
    // this.eventHub.$on("closeAddIPCRSupportUtilDialog", () => {
    //   this.initialize();
    // });
  },
  computed: {
    getCurrentTaggedTotal() {
      let total = 0;
      for (let i = 0; i < this.tagged_head_data.length; i++) {
        total += parseInt(this.tagged_head_data[i].target);
      }
      return total;
    },

    getPositionToTag() {
      let toTag = "";
      let label = "";
      let canTag = true;
      if (this.myTaggingType && this.myTaggingType.type == "vp") {
        label = "Tag to";
        if (this.myTaggingType.office_type != "academic affairs") {
          toTag = "Directors";
        } else {
          toTag = "Deans/Directors";
        }
      } else if (this.myTaggingType && this.myTaggingType.type == "director") {
        label = "Tag to";
        toTag = "Unit Heads";
      } else if (this.myTaggingType && this.myTaggingType.type == "dean") {
        canTag = true;
        label = "Tag to";
        toTag = "Faculty/Faculties";
      } else if (this.myTaggingType && this.myTaggingType.type == "unit_head") {
        canTag = false;
        label = "Tag to";
        toTag = "Personnel/s";
      } else if (
        this.myTaggingType &&
        this.myTaggingType.type == "prog_chair"
      ) {
        canTag = false;
        label = "Tag to";
        toTag = "Faculty/Faculties";
      }
      return {
        label,
        toTag,
        canTag,
      };
    },
    isTargetNeedForTagging() {
      let needed = true;

      if (this.myTaggingType && this.myTaggingType.type == "unit_head") {
        needed = true;
      } else if (
        this.myTaggingType &&
        this.myTaggingType.type == "prog_chair"
      ) {
        needed = false;
      }
      return needed;
    },
  },
  beforeDestroy() {
    this.eventHub.$off("closeAddOPCRTargetsDialog");
    this.eventHub.$off("closeUpdateOPCRSupportFunctionDialog");
    this.eventHub.$off("closeUpdateStrategicTargetSuccessIndicatorDialog");
    // this.eventHub.$off("closeMPORDialog");
    // this.eventHub.$off("closeUpdateSupportFunctionDialog");
  },

  methods: {
    getOipNumber(item) {
      const index = this.dataItem
        .filter((i) => !i.code)
        .findIndex((i) => i === item);

      return `OIP - ${String(index + 1).padStart(3, "0")}`;
    },
    initialize() {
      this.loading = true;
      this.loadRemarks(this.data.target_submission.id);

      this.axiosCall(
        "/opcr-target/getMyOPCRTargetBy/" + this.data.id + "/" + this.tab,
        "GET",
      ).then((res) => {
        if (res) {
          console.log("Init", res.data);
          this.dataItem = res.data;
          this.loading = false;
        }
      });
    },

    setPendingClass(item) {
      if (this.tab != 3) {
        let list = item.pending_remarks;
        let has = false;
        if (list) {
          for (let i = 0; i < list.length; i++) {
            if (list[i].isOpenned == 0) {
              has = true;
              break;
            }
          }
          if (has) {
            return "red lighten-4";
          }
        }
        return "";
      }

      return "";
    },

    hasUnOpennedRemarks(list) {
      if (list && list.length > 0) {
        let has = false;
        for (let i = 0; i < list.length; i++) {
          if (list[i].isOpenned == 0) {
            has = true;
            break;
          }
        }
        if (has) {
          return has;
        } else {
          if (this.shouldSubmit()) {
            return true;
          }
        }
      } else {
        return false;
      }
    },

    showPendingRemarks(item) {
      this.pendingList = [];
      setTimeout(() => {
        this.pendingList = item;
      }, 100);
    },

    getUserName(id) {
      console.log("UID", id);
      let idx = this.usersList.findIndex((el) => el.usID == id);

      return this.usersList[idx].name;
    },

    shouldSubmit() {
      if (this.isSubmitted == 0) {
        return true;
      } else {
        if (this.data) {
          let approval_arr = [
            this.data.target_submission.imm_approval_status,
            this.data.target_submission.planning_user_approval_status,
            this.data.target_submission.cpmt_approval_status,
            this.data.target_submission.cpmt_head_approval_status,
            this.data.target_submission.president_approval_status,
          ];
          console.log("APPROVL ARR", approval_arr);
          if (approval_arr.includes(3)) {
            return true;
          } else {
            return false;
          }
        } else {
          return true;
        }
      }
    },

    loadRemarks(id) {
      if (id) {
        this.axiosCall("/remarks/" + id + "/OPCR_TARGET_APPROVAL", "GET").then(
          (res) => {
            if (res.data) {
              console.log("remarks", res.data);
              this.remarksData = res.data;
            }
          },
        );
      }
    },
    closeD() {
      this.eventHub.$emit("closeOPCRTargetDialog", false);
      this.confirmSubmitDialog = false;
      this.confirmBtnLoading = false;
      this.isSubmitLoading = false;
      this.dialog = false;
    },
    edit(item) {
      if (this.tab != 3) {
        this.isToUpdate = this.data.id == item.opcrID ? true : false;
        if (this.tab == 1) {
          this.opcrData = item;
        } else {
          if (item.isOIP) {
            this.opcrData = item;
          } else {
            this.opcr1Data = item;
          }
        }
        this.action = "Update";
      } else {
        this.opcrSupData = item;
        this.action = "Update";
      }
    },

    getMyFilteredUserList() {
      let filtered = [];
      let off = this.$store.state.emp.officeID;
      // console.log(
      //   "OFF",
      //   off,
      //   this.myTaggingType.office_type,
      //   this.myTaggingType.type
      // );
      if (this.myTaggingType && this.myTaggingType.type == "vp") {
        for (let i = 0; i < this.usersList.length; i++) {
          if (this.myTaggingType.office_type != "academic affairs") {
            if (
              (this.usersList[i].office_underID == off &&
                this.usersList[i].roleID == 7) ||
              this.usersList[i].officeID == off
            ) {
              filtered.push(this.usersList[i]);
            }
          } else {
            if (
              (this.usersList[i].office_underID == off &&
                (this.usersList[i].roleID == 7 ||
                  this.usersList[i].roleID == 8)) ||
              this.usersList[i].officeID == off
            ) {
              filtered.push(this.usersList[i]);
            }
          }
        }
      } else if (this.myTaggingType.type == "director") {
        for (let i = 0; i < this.usersList.length; i++) {
          if (this.myTaggingType.office_type == "admin and finance") {
            if (
              (this.usersList[i].office_underID == off &&
                (this.usersList[i].roleID == 9 ||
                  this.usersList[i].roleID == 1)) ||
              this.usersList[i].officeID == off
            ) {
              filtered.push(this.usersList[i]);
            }
          } else {
            if (
              (this.usersList[i].office_underID == off &&
                this.usersList[i].roleID == 9) ||
              this.usersList[i].officeID == off
            ) {
              filtered.push(this.usersList[i]);
            }
          }
        }
      } else if (this.myTaggingType.type == "dean") {
        for (let i = 0; i < this.usersList.length; i++) {
          if (
            ((this.usersList[i].office_underID == off ||
              this.usersList[i].officeID == off) &&
              this.usersList[i].roleID == 12) ||
            this.usersList[i].officeID == off
          ) {
            filtered.push(this.usersList[i]);
          }
        }
      } else if (
        this.myTaggingType.type == "unit_head" ||
        this.myTaggingType.type == "prog_chair"
      ) {
        for (let i = 0; i < this.usersList.length; i++) {
          if (
            ((this.usersList[i].office_underID == off ||
              this.usersList[i].officeID == off) &&
              this.usersList[i].roleID == 2) ||
            this.usersList[i].officeID == off
          ) {
            filtered.push(this.usersList[i]);
          }
        }
      }

      return filtered;
    },

    tag(item) {
      this.itemForTagging = item;
      this.taggingType = item.taggingType;
      console.log(this.myTaggingType.type, item);
      if (
        // this.myTaggingType.type == "unit_head"
        ["unit_head", "dean"].includes(this.myTaggingType.type)
      ) {
        let url =
          "/opcr-target/getTaggedPersonnelByTargetId/" +
          item.id +
          "/" +
          this.myTaggingType.type +
          "/sp";
        // this.axiosCall(
        //   "/opcr-target/getTaggedPersonnel/" +
        //     item.OpcrPapTargetDistributedTaggingID +
        //     "/" +
        //     this.myTaggingType.type +
        //     "/sp",
        //   "GET",
        // ).then((res) => {
        //   let data = res.data;
        //   console.log("asdasd", res.data);
        //   for (let i = 0; i < data.length; i++) {
        //     data[i].head_user.name = this.toTitleCase(data[i].head_user.name);
        //   }
        //   this.tagged_head_data = data;
        // });

        this.axiosCall(url, "GET").then((res) => {
          let data = res.data;
          console.log("asdasd", res.data);
          for (let i = 0; i < data.length; i++) {
            data[i].head_user.name = this.toTitleCase(data[i].head_user.name);
          }
          this.tagged_head_data = data;
        });

        this.taggingDialog = true;
      } else {
        this.sdp_target_format = item.sdp_target_format;

        if (this.myTaggingType.type != "vp") {
          console.log("called me!", this.myTaggingType);
          if (this.myTaggingType.office_type == "planning") {
            this.target_to_distribute =
              item.sdp_target_format == "numeric"
                ? item.target
                : item.target + "%";
          } else {
            this.target_to_distribute =
              item.sdp_target_format == "numeric"
                ? item.tagged_target
                : item.tagged_target + "%";
          }
        } else {
          this.target_to_distribute =
            item.sdp_target_format == "numeric"
              ? item.target
              : item.target + "%";
        }
        this.tagged_head_data = [];
        this.taggingDialog = true;

        this.axiosCall(
          "/opcr-target/getTaggedOffices/" +
            item.id +
            "/" +
            this.myTaggingType.type +
            "/sp",
          "GET",
        ).then((res) => {
          console.log("CALLED TAGGING TO", res.data, this.myTaggingType);
          let data = res.data;
          for (let i = 0; i < data.length; i++) {
            data[i].head_user.name = this.toTitleCase(data[i].head_user.name);
          }
          this.tagged_head_data = data;
        });
      }
    },

    add_head_tagging() {
      this.tagHeadAction = "Add";

      if (this.tagged_head_data.length > 0) {
        let list = this.getMyFilteredUserList();
        for (let i = 0; i < this.tagged_head_data.length; i++) {
          for (let j = 0; j < list.length; j++) {
            if (this.tagged_head_data[i].head_user.usID == list[j].usID) {
              list.splice(j, 1);
              break;
            }
          }
        }
        this.tempHeadsList = list;
      } else {
        this.tempHeadsList = this.getMyFilteredUserList();
      }

      console.log("tagging list", this.tempHeadsList);
      this.tagged_head_temp_data = null;
      this.head_target = null;
      this.headsDialog = true;
    },

    removeTaggedOnClick(item) {
      this.tagged_head_temp_data = null;
      console.log("REMOVED ON LCIK", item);
      for (let i = 0; i < this.tagged_head_data.length; i++) {
        if (this.tagged_head_data[i].head_user.usID == item.head_user.usID) {
          if (!item.opcrPapTargetDistributedTaggingID) {
            this.tagged_head_data.splice(i, 1);
          } else {
            this.untagList.push(this.tagged_head_data[i]);
            this.tagged_head_data.splice(i, 1);
          }
        }
      }
    },

    edit_tag(item, index) {
      // this.getHeadUsers();
      console.log(item, index);
      let allHeadList = this.getMyFilteredUserList();
      console.log("TEMPHEAD", allHeadList);
      // setTimeout(() => {
      let tempTaggedHeads = [];
      if (this.tagged_head_data.length > 1) {
        for (let i = 0; i < this.tagged_head_data.length; i++) {
          if (this.tagged_head_data[i].head_user.usID != item.head_user.usID) {
            tempTaggedHeads.push(this.tagged_head_data[i]);
          }
        }

        if (tempTaggedHeads.length > 0) {
          let list = this.getMyFilteredUserList();
          for (let i = 0; i < tempTaggedHeads.length; i++) {
            for (let j = 0; j < list.length; j++) {
              if (tempTaggedHeads[i].head_user.usID == list[j].usID) {
                list.splice(j, 1);
                break;
              }
            }
          }
          this.tempHeadsList = list;
        }
      } else {
        this.tempHeadsList = allHeadList;
      }

      this.tagIdxToUpdate = index;
      this.tagHeadAction = "Update";

      this.head_target = item.target;
      if (typeof item.head_user.usID == "number") {
        this.tagged_head_temp_data = item.head_user.usID.toString();
      } else {
        this.tagged_head_temp_data = item.head_user.usID;
      }

      this.headsDialog = true;
      // }, 100);
    },

    untag(item) {
      this.unTagUser = item;
      this.unTagDialog = true;
    },

    confirmUntag() {
      // console.log(this.unTagUser);
      this.removeTaggedOnClick(this.unTagUser);
      this.unTagUser = null;
      this.unTagDialog = false;
    },
    cancelUntag() {
      this.unTagUser = null;
      this.unTagDialog = false;
    },

    closeHeadsDialog() {
      this.tagHeadAction = null;
      this.headsDialog = false;
    },

    saveTaggedHeads() {
      if (this.isTargetNeedForTagging) {
        let todistribute;
        let target_to_distribute = this.target_to_distribute.toString();

        if (target_to_distribute.includes("%")) {
          todistribute = this.target_to_distribute.slice(0, -1);
        } else {
          todistribute = this.target_to_distribute;
        }
        if (this.getCurrentTaggedTotal <= todistribute) {
          let tempT =
            parseInt(this.getCurrentTaggedTotal) + parseInt(this.head_target);
          if (tempT <= todistribute) {
            for (let j = 0; j < this.usersList.length; j++) {
              if (this.tagged_head_temp_data == this.usersList[j].usID) {
                this.tagged_head_data.push({
                  head_user: this.usersList[j],
                  target: this.head_target,
                });
                break;
              }
            }
          } else {
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "error";
            this.fadeAwayMessage.header = "System Message";
            this.fadeAwayMessage.message =
              "Total tagged targets exceeded the target to distribute!";
          }
        } else {
          this.fadeAwayMessage.show = true;
          this.fadeAwayMessage.type = "error";
          this.fadeAwayMessage.header = "System Message";
          this.fadeAwayMessage.message =
            "Total tagged targets exceeded the target to distribute!";
        }
      } else {
        for (let j = 0; j < this.usersList.length; j++) {
          if (this.tagged_head_temp_data == this.usersList[j].usID) {
            this.tagged_head_data.push({
              head_user: this.usersList[j],
              target: null,
            });
            break;
          }
        }
      }

      this.closeHeadsDialog();
    },

    updateTaggedHeads() {
      for (let j = 0; j < this.usersList.length; j++) {
        if (this.tagged_head_temp_data == this.usersList[j].usID) {
          this.tagged_head_data[this.tagIdxToUpdate].head_user = this.usersList[
            j
          ];
          this.tagged_head_data[this.tagIdxToUpdate].target = this.head_target;
          break;
        }
      }
      this.tagIdxToUpdate = null;
      this.closeHeadsDialog();
    },

    saveTagging() {
      if (this.isTargetNeedForTagging) {
        let todistribute;
        let target_to_distribute = this.target_to_distribute.toString();
        if (target_to_distribute.includes("%")) {
          todistribute = this.target_to_distribute.slice(0, -1);
        } else {
          todistribute = this.target_to_distribute;
        }

        if (this.getCurrentTaggedTotal == parseInt(todistribute)) {
          this.taggingBtnLoading == true;
          let data = {
            taggingType: this.taggingType,
            opcrPapTargetDistributedTaggingID: this.itemForTagging
              .OpcrPapTargetDistributedTaggingID
              ? this.itemForTagging.OpcrPapTargetDistributedTaggingID
              : null,
            idToTag: this.itemForTagging.id,
            tagged_head_data: JSON.stringify(this.tagged_head_data),
            untagList: JSON.stringify(this.untagList),
            sp_type: this.itemForTagging.sp_type,
            opcrID: this.itemForTagging.opcrID,
          };
          console.log(data);

          this.axiosCall("/opcr-target/save-sp-tagging", "POST", data).then(
            (res) => {
              if (res.data.status == 201) {
                this.taggingDialog = false;
                this.taggingBtnLoading = false;
                this.itemForTagging = null;
                this.tagged_head_data = [];
                this.untagList = [];
                this.fadeAwayMessage.show = true;
                this.fadeAwayMessage.type = "success";
                this.fadeAwayMessage.header = "System Message";
                this.fadeAwayMessage.message = res.data.msg;
              } else {
                this.fadeAwayMessage.show = true;
                this.fadeAwayMessage.type = "error";
                this.fadeAwayMessage.header = "System Message";
                this.fadeAwayMessage.message = res.data.msg;
                this.taggingBtnLoading = false;
              }
            },
          );
        } else {
          if (this.getCurrentTaggedTotal > parseInt(todistribute)) {
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "error";
            this.fadeAwayMessage.header = "System Message";
            this.fadeAwayMessage.message =
              " Total tagged targets exceeded the target to distribute!";
          } else {
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "error";
            this.fadeAwayMessage.header = "System Message";
            this.fadeAwayMessage.message =
              "Please tag director/heads accordingly!";
          }
        }
      } else {
        this.taggingBtnLoading == true;
        let data = {
          taggingType: this.taggingType,
          opcrPapTargetDistributedTaggingID: this.itemForTagging
            .OpcrPapTargetDistributedTaggingID
            ? this.itemForTagging.OpcrPapTargetDistributedTaggingID
            : null,
          idToTag: this.itemForTagging.id,
          tagged_head_data: JSON.stringify(this.tagged_head_data),
          typeOfTarget: "sp",
          untagList: JSON.stringify(this.untagList),
        };

        this.axiosCall(
          "/opcr-target/save-opcr-to-ipcr-tagging",
          "POST",
          data,
        ).then((res) => {
          if (res.data.status == 201) {
            this.taggingDialog = false;
            this.taggingBtnLoading = false;
            this.itemForTagging = null;
            this.tagged_head_data = [];
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "success";
            this.fadeAwayMessage.header = "System Message";
            this.fadeAwayMessage.message = res.data.msg;
          } else {
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "error";
            this.fadeAwayMessage.header = "System Message";
            this.fadeAwayMessage.message = res.data.msg;
            this.taggingBtnLoading = false;
          }
        });
      }
    },

    submitTarget() {
      this.confirmSubmitDialog = true;
    },

    confirmSubmit() {
      this.confirmBtnLoading = true;
      // this.isSubmitLoading = true;
      this.axiosCall("/opcr-target/submitTargets/" + this.id, "PATCH").then(
        (res) => {
          if (res.data.status == 200) {
            this.confirmBtnLoading = false;
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "success";
            this.fadeAwayMessage.header = "System Message";
            this.fadeAwayMessage.message = res.data.msg;
            this.closeD();
          } else if (res.data.status == 400) {
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "error";
            this.fadeAwayMessage.header = "System Message";
            this.fadeAwayMessage.message = res.data.msg;
          }
        },
      );
    },

    cancelConfirm() {
      this.confirmSubmitDialog = false;
    },

    AddFunction() {
      this.opcrData = { id: null, year: this.data.year };
      this.action = "Add";
    },

    changeTab(tab) {
      this.activeTab = tab;
      this.tab = tab.id;
      this.initialize();
    },
    deleteItem(item) {
      this.itemToDelete = item;
      this.confirmDialog = true;
    },
    cancelDelete() {
      this.itemToDelete = null;
      this.confirmDialog = false;
    },

    confirmDelete() {
      this.isButtonLoading = true;
      this.axiosCall(
        "/opcr-target/deleteOPCRTarget/" +
          this.itemToDelete.id +
          "/" +
          this.tab,
        "DELETE",
      ).then((res) => {
        if (res.data.status == 200) {
          this.confirmDialog = false;
          this.fadeAwayMessage.show = true;
          this.fadeAwayMessage.type = "success";
          this.fadeAwayMessage.header = "System Message";
          this.fadeAwayMessage.message = res.data.msg;
          this.isButtonLoading = false;
          this.itemToDelete = null;
          this.confirmDialog = false;

          this.initialize();
        } else {
          this.fadeAwayMessage.show = true;
          this.fadeAwayMessage.type = "error";
          this.fadeAwayMessage.header = "System Message";
          this.fadeAwayMessage.message = res.data.msg;
          this.isButtonLoading = false;
        }
      });
    },

    getHeadUsers() {
      this.axiosCall(
        "/user-details/getUsersHeadProgChairAbove_Office",
        "GET",
      ).then((res) => {
        let data = res.data;
        data.forEach((element, i) => {
          data[i].name = this.toTitleCase(element.name);
        });
        this.usersList = data;
        console.log("USERS", res.data);
      });
    },

    getMyTaggingType() {
      this.axiosCall("/opcr-target/getMyTaggingType", "GET").then((res) => {
        this.myTaggingType = res.data;
      });
    },
  },
};
</script>
<style scoped></style>
